import React from 'react';
import { Card, CardBody, Row, Col } from 'reactstrap';
import AdvancedFilter from "./advanced-filter";

const UserDashboard = () => {
  document.title = "Dashboard | BIGData";

  return (
    <div className="page-content pt-0" style={{ paddingTop: 0, marginTop: 0 }}>
      {/* فلترة متقدمة بنفس ستايل صفحة الداشبورد الأساسية */}
      <Row>
        <Col xl="12">
          <AdvancedFilter />
        </Col>
      </Row>

      {/* مساحة لعرض النتائج لاحقاً */}
      <Row className="mt-4">
        <Col xl="12">
          <Card className="shadow-sm">
            <CardBody>
              <h5 className="mb-3">النتائج</h5>
              <div className="text-muted">
                لا توجد نتائج للعرض حالياً. يمكنك تطبيق الفلاتر أعلاه ثم إظهار البطاقات/الجداول هنا لاحقاً.
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default UserDashboard;
